import { postRedeemGift } from "@/services/redeem-gift/redeem-gift";
import { getError } from "@/utils/get-error/get-error";
import { useCallback, useState } from "react"


const useRedeemGift = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [successClaim, setSuccessClaim] = useState<boolean>(false);


  const handleReset = useCallback(()=>{
    setLoading(false);
    setError(null);
    setSuccessClaim(false)
  }, [])

  const handleRedeem = useCallback(async(code: string, benefit_address: string)=>{
    try {
      setError(null);
      setLoading(true);
      await postRedeemGift({ benefit_address: benefit_address, benefit_claim_id: code });
      setSuccessClaim(true)
    } catch (e) {
      if (e instanceof Error){
        setError(getError(e) || 'Ocurrio un error desconosido')
      } else {
        setError('Ocurrio un error desconosido')
      }
    } finally {
      setLoading(false);
    }
  },[])

  return {
    handleReset,
    handleRedeem,
    loading,
    error,
    successClaim
  }
}

export default useRedeemGift;